import "./IconButtonContainer.scss"
import { IconButtonContainer, IconButtonProps } from "./IconButtonContainer";
import IconGoBack from "../icon/IconGoBack";

export default function IconButtonGoBack(props: IconButtonProps) {
    return <IconButtonContainer {...props}>
        <IconGoBack />
    </IconButtonContainer>
}